angular
    .module('eficienciaFiscalModule')
    .directive('efOnDrop', () => {
        return {
            restrict: 'A',
            scope: {
                'efOnDrop': '&'
            },
            link: (scope, elem) => {
                $(elem)
                    .on('drop dragover', $event => $event.preventDefault())
                    .on('drop', $event => {
                        scope.$apply(() => scope.efOnDrop({$event}))
                    })
            }
        }
    })
